import {action, observable} from 'mobx';

class CalendarState {
  FullCalendar;
  dayGridPlugin;
  timeGridPlugin;
  frLocale;
  agent;

  @observable startDate = new Date().toISOString();
  @observable endDate = new Date().toISOString();

  @observable events = [];
  @observable isLoading = false;
  @observable selectedEvent = {};

  @action async load() {
    const [FullCalendar, dayGridPlugin, timeGridPlugin, frLocale] = await Promise.all([
      import('@fullcalendar/react'),
      import('@fullcalendar/daygrid'),
      import('@fullcalendar/timegrid'),
      import('@fullcalendar/core/locales/fr')
    ]);

    this.FullCalendar = FullCalendar.default;
    this.dayGridPlugin = dayGridPlugin.default;
    this.timeGridPlugin = timeGridPlugin.default;
    this.frLocale = frLocale.default;
  }

  @action setInteractiveAgent(agent) {
    this.agent = agent;
  }

  @action async updateDates(startDate, endDate) {
    this.startDate = startDate;
    this.endDate = endDate;
  }
}

export default CalendarState;
